import { toggleClass, isNumeric } from '../helpers/attribute-helper';

export default class LeadTimeSpreadsheet {
  constructor(parent) {
    this.parent = parent;
    this.el = parent.el;
    this.pricing = parent.pricing;
    this.car = parent.car;
    this.navigation = parent.navigation;
    this.dateLocale = this.el.dataset.dateLocale;
    this.leadTimeWrapper = this.el?.querySelector('.lead-time-wrapper')
    this.leadTimeDropdown = this.el?.querySelector('.lead-time-dropdown');
    this.leadTimeModal = this.el?.querySelector('#lead-time-modal');
    this.leadTimeSection = this.el?.querySelector('.lead-time-section');
    this.lastFocusedElement = null;
    this.leadTimeEditLinks = this.el?.querySelectorAll('.lead-time-table-icon-col a');
    
  }

  async update() {
    await this.pricing.waitForMTOPricing();

    toggleClass(this.el, null, 'data-mto-lead-time-toggle', 'hide', false, (cond) => !!cond);
    toggleClass(this.el, null, 'data-car-mto-lead-time-toggle', 'hide', false, (cond) => !!cond);
    toggleClass(this.el, null, 'data-car-colour-lead-time-toggle', 'hide', false, (val) => isNumeric(val) && val > 0);
    toggleClass(this.el, null, 'data-car-trim-lead-time-toggle', 'hide', false, (val) => isNumeric(val) && val > 0);
    toggleClass(this.el, null, 'data-car-colour-trim-lead-time-toggle', 'hide', false, (val) => isNumeric(val) && val > 0);
    toggleClass(this.el, null, 'data-car-lead-time-toggle', 'hide', false, (cond) => !!cond);
  }

  getMTODates() {
    return {};
  }

  getCarMTODate(mtoDates) {
    return null;
  }

  getCarColourDate() {
    return null;
  }

  getCarDate(tempCar) {
    return null;
  }

  getCarEstimatedMonth(car) {
    return null;
  }
}